/**
 * Route for `fallback-traffic-rules`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FallbackTrafficRulesPage } from "../features/fallback-traffic-rules/FallbackTrafficRulesPage";

export const fallbackTrafficRulesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fallback-traffic-rules",
	component: FallbackTrafficRulesPage,
});

export default fallbackTrafficRulesRoute;
